'use strict';

var breakpoints = require('../components/breakpoints');

module.exports = function () {
    var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];

    sizes.forEach(function (size) {
        var selector = '.collapsible-' + size + ' .title';

        // Shared function to toggle collapsible state
        var toggleCollapsible = function (element) {
            var $element = $(element);
            var $container = $element.parents('.collapsible-' + size);

            $container.toggleClass('active');

            if ($container.hasClass('active')) {
                $element.attr('aria-expanded', true);
            } else {
                $element.attr('aria-expanded', false);
            }
        };

        $('body').on('click', selector, function (e) {
            e.preventDefault();
            toggleCollapsible(this);
        });
    });

    $('body').on('keydown', '.collegiate-link-list-collapsible__collapsible-heading.col-12.title.no-arrow, .dropdown-link-list-component .title, .js_refinement-heading', function (evt) {
        if (evt.keyCode === 13 || evt.keyCode === 32) {
            evt.preventDefault();
            $(this).trigger('click');
        }
    });

    $(sizes.map(size => '.collapsible-' + size).join(',')).each((i, el) => {
        if (breakpoints.isDesktopView() && $(el).hasClass('active-desktop') && !$(el).hasClass('active')) {
            $(el).addClass('active');
            $(el).find('.title:first').attr('aria-expanded', true);
        }
        if (breakpoints.isMobileView() && $(el).hasClass('active-mobile') && !$(el).hasClass('active')) {
            $(el).addClass('active');
            $(el).find('.title:first').attr('aria-expanded', true);
        }
    });
};
